import { useState } from 'react';

export const useSearch = () => useState('');
